import React, { memo } from 'react';


const FormGroupInputs = ({ formGroup }) =>
	formGroup.inputs?.length > 0 &&
	formGroup.inputs.map(({ CustomizedInput, Input, column, fieldProps, ...rest }, i) => (
		<Input
			{...fieldProps}
			{...formGroup.fieldProps}
			{...rest}			
			column={column}
			size={{ xs: 12, md: column.columnSize || formGroup.columnSize || 12 }}	
			key={`form-group-input-${i}`}
		/>
	));
export default memo(FormGroupInputs);